<template>

	<ListTile>


		<template v-slot:icon>
			<ProfilePicByUrl :imageUrl="user.picture" class="profile-pic__my-referrals"/>
		</template>




		<template v-slot:details>
			<v-row class="my-referral-tile__details d-flex flex-row align-center">
				<v-col cols="4" class="my-referral-tile__nickname">
					{{ user.name }}
				</v-col>

				<v-col cols="8" class="my-referral-tile__description">
					Member Since: {{ formatDate(user.created_at) }}
				</v-col>
			</v-row>
		</template>




		<template v-slot:append-right>
			<div class="d-flex flex-row align-center">

				<CoinChip :coins_amount="user.referrer_coins_total" />


				<v-tooltip>
					<template v-slot:activator="{ props }">
						<v-icon v-bind="props" :icon="'mdi-alert-circle'" class="ml-2"></v-icon>
					</template>

					<span>
						You will earn 250 coins plus 5% of all your friend's future earnings,
						<br>
						once your friends collect 200 coins from qualifying offers.
					</span>
				</v-tooltip>

			</div>
		</template>


	</ListTile>
</template>



<script setup lang="ts">

import { User } from "@/interfaces/User";
import { formatDate } from "@/utils/utils";
import ListTile from '@/components/Tiles/List-Tile.vue';
import CoinChip from "@/components/Common/CoinChip.vue";
import ProfilePicByUrl from "@/components/Profile/Profile-Pic-By-URL.vue";

defineProps<{
	user: User
}>();

</script>